import { setComponentOverrides } from '@utima/ui/overrides';

/**
 * @utima/ui component overrides
 */
setComponentOverrides({
  input: {
    input:
      'ring-0 rounded-md border !border-chat-input-border bg-chat-input-background text-chat-input-foreground',
  },
});
